import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  device: 'desktop',
  loading: false,
  games: null,
  lobbyGames: null,
  //
  providers: null,
  activeProvider: 'all',
  categories: null,
  activeCategory: 'Lobby',
  tags: null,
  activeTag: null,
  //
  showAllGames: false,
  showFavoriteGames: false,
  topWins: null,
  searchGame: '',
};
export const gameSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setDeviceSize: (state, action) => {
      state.device = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setGames: (state, action) => {
      state.games = action.payload;
    },
    setLobbyGames: (state, action) => {
      state.lobbyGames = action.payload;
    },
    //
    setProviders: (state, action) => {
      state.providers = action.payload;
    },
    setActiveProvider: (state, action) => {
      state.activeProvider = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setActiveCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
    setTags: (state, action) => {
      state.tags = action.payload;
    },
    setActiveTag: (state, action) => {
      state.activeTag = action.payload;
    },
    setShowAllGames: (state, action) => {
      state.showAllGames = action.payload;
    },
    setShowFavoriteGames: (state, action) => {
      state.showFavoriteGames = action.payload;
    },
    setTopWins: (state, action) => {
      state.topWins = action.payload;
    },
    setSearchGame: (state, action) => {
      state.searchGame = action.payload;
    },
  },
});
export const {
  setDeviceSize,
  setLoading,
  setGames,
  setProviders,
  setActiveProvider,
  setActiveCategory,
  setCategories,
  setTags,
  setActiveTag,
  setLobbyGames,
  setShowAllGames,
  setShowFavoriteGames,
  setTopWins,
  setSearchGame,
} = gameSlice.actions;
export default gameSlice.reducer;
